/*
 *
 * TermsConditions constants
 *
 */

export const DEFAULT_ACTION = "app/TermsConditions/DEFAULT_ACTION";
export const CHECK_TERMS_CONDITIONS = "app/TermsConditions/CHECK_TERMS_CONDITIONS";
